import * as initialMoment from "moment"
import {get} from "lodash"

import authentication from "@irati/auth"
import {Deal, UserDateOfBirth} from "@irati/types"
import RedemptionEventOptions from "@irati/deals/types/enums/RedemptionEventOptions"
import {dobObjectToString} from "@irati/identity/utils/user/dob"

/*
@todo: This is a hack to get around the problem discussed here:
https://github.com/aurelia/skeleton-navigation/issues/606
*/
// @ts-ignore
const moment = initialMoment.default || initialMoment

type Moment = initialMoment.Moment

export const userDOBExists = (): boolean => {
  return dobSetByUser(authentication.user().dateOfBirth)
}

export const adjustYear = (dob: string): Moment | undefined => {
  const TODAYS_DATE = moment()
  const THIS_YEAR = moment().year().toString()

  // Prepends a year on date of birth, and converts to a 'moment' - to help calculate earliest and latest redemption dates

  const adjustedDOB = moment(dob.length < 10 ? `${THIS_YEAR}-${dob}` : dob.replace(/\d{4}/, THIS_YEAR))

  if (!adjustedDOB.isValid) return

  // Adjusting the DOB year, if applicable

  if (TODAYS_DATE.month() === 0 && moment(adjustedDOB).month() === 11) {
    adjustedDOB.subtract(1, "y") // If current month is January, and bday month is December - refer to December of last year
  }

  if (TODAYS_DATE.month() === 11 && moment(adjustedDOB).month() === 0) {
    adjustedDOB.add(1, "y") // If current month is December, and bday month is January - refer to January of next year
  }

  return adjustedDOB
}

export const getEarliestRedemptionDate = (deal: Deal, dob: UserDateOfBirth = authentication.user().dateOfBirth): Moment | undefined => {
  const adjustedDOB = adjustYear(dobObjectToString(dob)!)

  if (!adjustedDOB) return

  const daysBefore = get(deal, "productConfig.limits.inWindow.eventWindow.daysBefore", 0)

  return moment(adjustedDOB).subtract(daysBefore, "d")
}

export const getLatestRedemptionDate = (deal: Deal, dob: UserDateOfBirth = authentication.user().dateOfBirth): Moment | undefined => {
  const adjustedDOB = adjustYear(dobObjectToString(dob)!)

  if (!adjustedDOB) return

  const daysAfter = get(deal, "productConfig.limits.inWindow.eventWindow.daysAfter", 0)

  return moment(adjustedDOB).add(daysAfter, "d")
}

export const isUserDOBRequired = (deal: Deal): boolean => {
  const redemptionEventType = get(deal, "productConfig.limits.inWindow.eventWindow.type", null)

  return redemptionEventType === RedemptionEventOptions.UsersDateOfBirth
}

export const userDOBIsWithinRedemptionWindow = (deal: Deal, dob: UserDateOfBirth = authentication.user().dateOfBirth): boolean => {
  if (!dobSetByUser(dob)) {
    return false
  }

  const TODAYS_DATE = moment()

  const earliestRedemptionDate = getEarliestRedemptionDate(deal, dob)
  const latestRedemptionDate = getLatestRedemptionDate(deal, dob)

  if (!earliestRedemptionDate || !latestRedemptionDate) return false

  return TODAYS_DATE.isBetween(earliestRedemptionDate, latestRedemptionDate, "d", "[]")
}

/**
 *
 * @param {object} dob
 * @description check to see if user has explicity set a dob,
 * if they haven't graph will return {day: 0, month: 0, year: 0}
 */
export const dobSetByUser = (dob: UserDateOfBirth) => {
  return dob.month !== 0 && dob.day !== 0
}
